module.exports = __webpack_public_path__ + "headerWhoWeAreSlide.cb12d9958b103f3ae5e1.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/coverPicks/headerWhoWeAreSlide.jpg
// module id = ../../../../../src/assets/coverPicks/headerWhoWeAreSlide.jpg
// module chunks = 0